export default "__VITE_ASSET__DUYq9j7e__"